/**
 * @generated SignedSource<<2a98cfd5c05f70671f650100d305d33a>>
 * @relayHash 3dcc9ec305f83712b2c2212027be35c0
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3dcc9ec305f83712b2c2212027be35c0

import { ConcreteRequest } from 'relay-runtime';
export type capacityGaugeChartsQuery$variables = Record<PropertyKey, never>;
export type capacityGaugeChartsQuery$data = {
  readonly todayPerformanceIndicatorsOverview: {
    readonly appointmentsLastHour: {
      readonly currentValue: number;
      readonly maxValue: number;
    };
    readonly appointmentsPerHour: {
      readonly currentValue: number;
      readonly maxValue: number;
    };
    readonly appointmentsThisHour: {
      readonly currentValue: number;
      readonly maxValue: number;
    };
    readonly totalAppointmentsClosedToday: number;
    readonly totalAppointmentsToday: {
      readonly currentValue: number;
      readonly maxValue: number;
    };
  } | null;
};
export type capacityGaugeChartsQuery = {
  response: capacityGaugeChartsQuery$data;
  variables: capacityGaugeChartsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentValue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maxValue",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TodayPerformanceIndicatorsOverviewOutput",
    "kind": "LinkedField",
    "name": "todayPerformanceIndicatorsOverview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceIndicatorOutput",
        "kind": "LinkedField",
        "name": "appointmentsLastHour",
        "plural": false,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceIndicatorOutput",
        "kind": "LinkedField",
        "name": "appointmentsPerHour",
        "plural": false,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceIndicatorOutput",
        "kind": "LinkedField",
        "name": "appointmentsThisHour",
        "plural": false,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceIndicatorOutput",
        "kind": "LinkedField",
        "name": "totalAppointmentsToday",
        "plural": false,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAppointmentsClosedToday",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "capacityGaugeChartsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "capacityGaugeChartsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "3dcc9ec305f83712b2c2212027be35c0",
    "metadata": {},
    "name": "capacityGaugeChartsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "00e90a662acf23b8a8b9e0f6de9ae22b";

export default node;
